import { AfterViewInit, Component, effect, ElementRef, signal, ViewChild } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { catchError, of } from 'rxjs';
import { SettlementKinds } from '../settlement.model';
import { Data2Service } from '@/common/data2.service';
import { DataBagService } from '@/common/data-bag.service';
import { DateService } from '@/common/date.service';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionService } from '@/common/question-dialog/question-dialog.service';
import { LoaderService } from '@/common/loader/loader.service';

@Component({
	selector: 'app-settlement-bonus-list',
	templateUrl: './settlement-bonus-list.component.html',
	styleUrls: ['./settlement-bonus-list.component.css'],
})
export class SettlementBonusListComponent extends ListComponent implements AfterViewInit {
	@ViewChild('fileSettlement', { static: false }) fileSettlement: ElementRef<HTMLElement>;
	@ViewChild('fileMobilityPackage', { static: false }) fileMobilityPackage: ElementRef<HTMLElement>;
	@ViewChild('fileFlix', { static: false }) fileFlix: ElementRef<HTMLElement>;
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	readonly toggleAllChecked = signal(false);

	protected itemsBeforeDataLoad = 6;
	protected apiUrl = 'settlements/settlementBonus';
	showTable = true;
	matData = new MatTableDataSource<any>();
	protected filterValue = '';
	protected lastClickedIndex = null;
	protected confirmedDriver = [];
	filters: any;
	parameters = {
		drivers: [],
		users: [],
		settlementBonusNames: [],
		settlementKinds: [
			{ id: 1, name: 'Dodatek' },
			{ id: 2, name: 'Potrącenie' },
		],
		confirm: [
			{ id: 1, name: 'Tak' },
			{ id: 2, name: 'Nie' },
		],
		workshop: [
			{ id: 1, name: 'Tak' },
			{ id: 2, name: 'Nie' },
		],
		massAction: [
			{ name: 'Potwierdź', value: true },
			{ name: 'Usuń potwierdzenie', value: false },
			{
				name: 'Przypisz osobę',
				value: false,
				kind: 'setOwner',
			},
		],
		driverKinds: [],
		vehicles: [],
	};

	sum = 0;
	sumIsSettled = 0;
	sumIsNotSettled = 0;
	action = {
		value: null,
		user: null,
		kind: null,
	};

	displayedColumns: string[] = [
		'checkbox',
		'id',
		'owner',
		'vehicle',
		'name',
		'value',
		'isSettled',
		'comment',
		'editAt',
		'createAt',
		'eventId',
		'confirmAt',
		'workshop',
		'edit',
	];

	checkAll(onOff: boolean): void {
		this.matData.filteredData.forEach((element) => {
			element.checked = onOff;
		});
	}

	areAllChecked(): boolean {
		const data = this.matData.filteredData;
		return data.length > 0 && data.every((row) => row.checked);
	}

	isAnyChecked(): boolean {
		return this.matData.filteredData.some((row) => row.checked) && !this.areAllChecked();
	}

	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected question: QuestionService,
		protected loader: LoaderService,
	) {
		super(api, bag, date, infobox, route, router, question, loader);
		effect(() => {
			this.checkAll(this.toggleAllChecked());
		});
	}

	protected loadBefore(): void {
		this.api.get('/driverKinds/', (result) => {
			this.parameters.driverKinds = result.data;
			this.loadData();
		});
		this.api.get('/drivers/', (result) => {
			this.parameters.drivers = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result) => {
			this.parameters.users = result.data;
			this.loadData();
		});
		this.api.get('/settlements/settlementBonusName/', (result) => {
			this.parameters.settlementBonusNames = result.data;
			this.loadData();
		});
		this.api.get('/vehicleTypes/', (result) => {
			this.parameters.vehicles = result.data;
			this.loadData();
		});
	}

	filtersSelected(data) {
		this.filters = data;
		if (!this.filters.date_from) {
			this.filters.date_from = this.date.daysAdd(-90);
		}
		if (!this.filters.date_to) {
			this.filters.date_to = this.date.daysAdd(+15);
		}
		this.loadData();
	}

	refreshFilter() {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	convertData(result) {
		this.sum = 0;
		this.sumIsSettled = 0;
		this.sumIsNotSettled = 0;
		result.forEach((element) => {
			this.sum += parseFloat(element.value);
			if (element.isSettled == '1') {
				this.sumIsSettled += parseFloat(element.value);
			} else {
				this.sumIsNotSettled += parseFloat(element.value);
			}
			const editBy_name = this.parameters.users.find((objFind) => element.editBy === objFind.id);
			element.editBy = editBy_name ? editBy_name.firstName + ' ' + editBy_name.lastName : '?';
			const createBy_name = this.parameters.users.find((objFind) => element.createBy === objFind.id);
			element.createBy = createBy_name ? createBy_name.firstName + ' ' + createBy_name.lastName : '?';
			element.isSettled = element.isSettled == '1' ? 'Tak' : 'Nie';
			element.confirm =
				element.confirmAt == null ? 'Niezatwierdzone' : element.confirmAt + ' ' + element.confirmByUser;
			element.workshop =
				element.workshopAt == null ? 'Niezatwierdzone' : element.workshopAt + ' ' + element.workshopByUser;
		});
		this.matData.data = result;
		return this.matData.data;
	}

	checkMultipleSelection(event, index) {
		if (event.shiftKey) {
			if (this.lastClickedIndex == null) {
				// index może być 0, dlatego nie !this.lastClicked
				return;
			}
			event.preventDefault(); // wsparcie dla Chrome'a :P
			const array = this.matData.sortData(this.matData.data, this.matData.sort);
			this.range(this.lastClickedIndex, index).forEach((iter: number) => {
				array[iter].checked = true;
			});
		}
		this.lastClickedIndex = index;
	}

	protected range(first, sec) {
		const start = Math.min(first, sec);
		const len = Math.abs(first - sec) + 1;
		return Array.from({ length: len }, (x, i) => i + start);
	}

	protected loadData(param?: string): void {
		super.loadData(param);
		this.toggleAllChecked.set(false);
	}

	massAction(action) {
		const checkedElements = this.matData.data.filter((element) => element.checked);
		let errors = '';
		if (!checkedElements.length) {
			errors += '<br>Nie wybrano żadnego dodatku';
		}
		if (!this.action.user && this.action.value.kind === 'setOwner') {
			errors += '<br>Nie wybrano osoby';
		}
		if (this.action.value === null) {
			errors += '<br>Nie wybrano opcji';
		}
		if (errors.length !== 0) {
			this.infobox.error(errors);
			return;
		}
		this.askQuestion('Zastanów Się. Jesteś pewien/a?', () => {
			this.isDriverConfirm(checkedElements, action, () => {
				this.confirmBonus(checkedElements, action, () => {
					this.action = {
						value: null,
						user: null,
						kind: null,
					};
					this.loadData();
				});
			});
		});
		return;
	}

	isDriverConfirm(elements, action, callback) {
		this.confirmedDriver = [];
		if (action.kind === 'setOwner') {
			this.api.command(
				'/settlements/settlementBonus/',
				{ data: elements, cmd: 'checkSettlementConfirm' },
				(result, error) => {
					this.confirmedDriver = result.data;
					callback();
				},
			);
		} else {
			this.api.command(
				'/driver/driverSummaryList/',
				{ data: elements, cmd: 'checkConfirmed' },
				(result, error) => {
					this.confirmedDriver = result.data;
					callback();
				},
			);
		}
	}

	confirmBonus(elements, action, callback) {
		if (action.kind === 'setOwner') {
			if (this.confirmedDriver.length !== 0) {
				this.infobox.error(
					'Zaznaczony kierowca ma zatwierdzny dodatek/potrącenie nie moża zmienić/dodać osoby odpowiedzialnej',
				);
				return;
			}
			elements.forEach((element) => {
				const data = {
					cmd: 'setOwner',
					action: action.value,
					id: element.id,
					setOwner: this.action.user,
				};
				this.api.command('/settlements/settlementBonus/', data, (result, error) => {
					if (error) {
						return;
					}
				});
			});
			callback();
		} else {
			if (this.confirmedDriver.length !== 0 && !action) {
				this.infobox.error(
					'Zanzaczony kierowca ma zatwierdzone wynagrodzenie, nie można wykonać akcji odtwierdź',
				);
				return;
			}
			elements.forEach((element) => {
				this.api.command(
					`/settlements/settlementBonus`,
					{
						id: element.id,
						cmd: 'confirm',
						action: action.value,
					},
					(result, error) => {
						if (error) {
							this.infobox.error(error.error.error);
							return;
						}
					},
				);
			});
			callback();
		}
	}

	askQuestion(question: string, callback: () => void): void {
		this.question.ask(question, 'questionId');
		const questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId !== 'questionId') {
				return;
			}
			questionSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			callback();
		});
	}

	addFiles(kind: string): void {
		switch (kind) {
			case SettlementKinds.MOBILITY_PACKAGE:
				this.fileMobilityPackage.nativeElement.click();
				break;
			case SettlementKinds.SETTLEMENT:
				this.fileSettlement.nativeElement.click();
				break;
			case SettlementKinds.FLIX:
				this.fileFlix.nativeElement.click();
				break;
			default:
				const value: never = kind as never;
				throw new Error(`There is no value like: ${value}`);
		}
	}

	uploadFile(event: { target: HTMLInputElement }, kind: string): void {
		this.api
			.uploadFile(this.getUrlKind(kind), event.target.files[0])
			.pipe(
				catchError((err) => {
					this.infobox.error(JSON.stringify(err?.error));
					return of(null);
				}),
			)
			.subscribe(() => {
				this.loadData();
			});
	}

	private getUrlKind(kind: string): string {
		switch (kind) {
			case SettlementKinds.MOBILITY_PACKAGE:
				return `/settlements/settlementMobilityPackage`;
			case SettlementKinds.SETTLEMENT:
				return `/settlements/SettlementImportFile`;
			case SettlementKinds.FLIX:
				return `/settlements/SettlementImportFlix`;
			default:
				const value: never = kind as never;
				throw new Error(`There is no value like: ${value}`);
		}
	}
}
